import { call, fork, put, take } from 'redux-saga/effects';
import {Api} from '../api';
import {Thing} from '../api/types';
import {fetchThings} from '../action/depotsCommands';
import {thingsFetched} from '../action/depotsEvents';
import {enqueueErrorSnackbar} from '../action/snackbarCommands';
import {getI18n} from 'react-i18next';
import Logger from '../common/logger';

export const onFetchThings = function*() {
    try {
        const things: Thing[] = yield call(Api.getThings);

        yield put(thingsFetched({ things }));
    } catch (e) {
        Logger('Saga').error(e);
        yield put(enqueueErrorSnackbar({ message: getI18n().t('snackbar.error.fetch_things') }));
    }
};

export function* fetchThingsFlow() {
    while (true) {
        yield take(fetchThings.toString());
        yield fork(onFetchThings);
    }
}
